import { render, staticRenderFns } from "./filing-haocai.vue?vue&type=template&id=54f840b2&scoped=true"
import script from "./filing-haocai.vue?vue&type=script&lang=js"
export * from "./filing-haocai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f840b2",
  null
  
)

export default component.exports